<div class="container">
  <div class="center-box">
    <div *ngFor="let item of legendCollection" class="content-align">
      <span class="legend-boxsize" [ngStyle]="{ 'background-color': item.colorCoding }"></span>
      <span class="legend-name">{{ item.legendName }}</span>
    </div>
  </div>
</div>
